import fetch from "isomorphic-fetch";

import { withAccountAuthHeaders } from "./apiHelpers";
import { apiConf } from "./index";

type ConfirmIndemnitiesTypesParams = {
    alias?: string;
    organisationId: string;
};
export function confirmIndemnities(params: ConfirmIndemnitiesTypesParams) {
    return fetch(
        withAccountAuthHeaders(
            `${apiConf.BACK_URL}/organisations/${params.organisationId}/confirm_indemnities`,
            { method: `PUT` },
        ),
    );
}
